import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
} from "@/components/ui/select";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  saldoDisp: number;
  formatCurrency: (v: number) => string;
  onSuccess?: () => void;
}

function getCsrfToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute("content") || "";
}

export function WithdrawModal({
  open,
  onOpenChange,
  saldoDisp,
  formatCurrency,
  onSuccess,
}: Props) {
  const [valor, setValor] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSalvando(true);
    setErro("");

    try {
      const response = await fetch("/anfitriao/financeiro/saques", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-TOKEN": getCsrfToken(),
        },
        body: JSON.stringify({
          valor,
          metodo: "pix",
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || "Erro ao solicitar saque.");
      }

      setValor("");
      onOpenChange(false);
      onSuccess?.();
    } catch (err) {
      setErro(err instanceof Error ? err.message : "Erro ao solicitar saque.");
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle className="text-xl font-700">Solicitar Saque</DialogTitle>
            <DialogDescription>
              Preencha os dados abaixo para solicitar seu saque.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-5 py-4">
            {erro && (
              <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                {erro}
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="valor">Valor (R$)</Label>
              <Input
                id="valor"
                type="number"
                step="0.01"
                min="1"
                placeholder="0,00"
                className="h-11"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                required
              />
              <p className="text-xs text-muted-foreground">
                Saldo disponível: {formatCurrency(saldoDisp)}
              </p>
            </div>

            <div className="space-y-2">
              <Label>Método de pagamento</Label>
              <div className="rounded-md border bg-slate-50 px-3 py-3 text-sm text-slate-700">
                PIX automático com a chave cadastrada no seu perfil.
              </div>
            </div>
          </div>

          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={salvando}
              className="gradient-primary text-primary-foreground font-600"
            >
              {salvando ? "Enviando..." : "Confirmar Solicitação"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}